import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import {AuthReducer} from './reducers/AuthReducer';
import {UserReducer} from './reducers/UserReducer';

const middleware = applyMiddleware(thunk);

const composeEnhancers =
    process.env.REACT_APP_ENV === 'development'
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
              trace: true,
              traceLimit: 25,
          })
        : null || compose;

const reducers = combineReducers({
    auth: AuthReducer,
    user: UserReducer,
});

export const store = createStore(reducers, composeEnhancers(middleware));
